// One-shot message handed across a full-page redirect to the login screen
// (the 401 interceptors reload the page, so React state cannot carry it).
const KEY = 'inspire_auth_notice';

export const SESSION_ENDED_NOTICE =
  'Your session has ended or your account is no longer active. Please sign in again.';

export function setAuthNotice(message) {
  try { sessionStorage.setItem(KEY, message); } catch (e) { /* storage unavailable */ }
}

export function consumeAuthNotice() {
  try {
    const m = sessionStorage.getItem(KEY);
    if (m) sessionStorage.removeItem(KEY);
    return m;
  } catch (e) {
    return null;
  }
}
